<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M2.7129149999999997,5.957826785888672C2.183923,5.799126785888672,1.883739,5.241646785888672,2.042437,4.712651785888672C2.201135,4.183659785888672,2.7586180000000002,3.8834757858886717,3.28761,4.0421737858886715C3.28761,4.0421737858886715,13.2876,7.042176785888672,13.2876,7.042176785888672C14.2378,7.327236785888672,14.2378,8.672766785888673,13.2876,8.957826785888672C13.2876,8.957826785888672,3.28761,11.957826785888672,3.28761,11.957826785888672C2.7586180000000002,12.116526785888672,2.201135,11.816336785888673,2.042437,11.287346785888673C1.883739,10.758356785888672,2.183923,10.20087678588867,2.7129149999999997,10.042176785888671C2.7129149999999997,10.042176785888671,9.52016,7.999996785888672,9.52016,7.999996785888672C9.52016,7.999996785888672,2.7129149999999997,5.957826785888672,2.7129149999999997,5.957826785888672C2.7129149999999997,5.957826785888672,2.7129149999999997,5.957826785888672,2.7129149999999997,5.957826785888672Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GreaterThan',
} as DefineComponent
</script>
